export type ExportDataDialogType = {
    exportData: string;
    targetVault: string;
    format: string;
    csvWarning: string;
    exportItems: string;
    cancel: string;
    allVaults: string;
    pleaseChoosePassword: string;
    choosePassword: string;
    enterPassword: string;
    pleaseChoosePasswordError: string;
    pleaseRepeatPassword: string;
    passwordNotRepeatedCorrectly: string;
};
